const paymentsTypes = {

  get: {
    request: "GET_PAYMENT_REQUEST",
    success: "GET_PAYMENT_SUCCESS",
    failure: "GET_PAYMENT_FAILURE"
  },

  export: {
    request: "EXPORTS_XLSX_PAYMENTS_REQUEST",
    success: "EXPORTS_XLSX_PAYMENTS_SUCCESS",
    failure: "EXPORTS_XLSX_PAYMENTS_FAILURE"
  },

  index: {
    request: "PAYMENT_INDEX_REQUEST",
    success: "PAYMENT_INDEX_SUCCESS",
    failure: "PAYMENT_INDEX_FAILURE"
  },

  receipt: {
    request: "PAYMENT_RECEIPT_REQUEST",
    success: "PAYMENT_RECEIPT_SUCCESS",
    failure: "PAYMENT_RECEIPT_FAILURE"
  },

  set_errors: "SET_PAYMENT_ERRORS"
}

export default paymentsTypes



// WEBPACK FOOTER //
// ./src/js/constants/paymentsTypes.js